import React from 'react';
import { Paragraph3, Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import S from './style/Dac7InfoCard';
import { useI18n } from '../../../../i18n';

const Dac7InfoCard = () => {
  const i18n = useI18n();
  return (
    <S.InfoCardContainer>
      <S.HeaderContainer>
        <S.DocumentLockIcon />
        <S.Title>{i18n`dlv_dac7_infocard_title`}</S.Title>
      </S.HeaderContainer>
      <S.ContentContainer>
        <Paragraph3 fontWeight={400} mb={16}>
          {i18n`dlv_dac7_infocard_description`}
        </Paragraph3>
        <Paragraph3 fontWeight={400} mb={16}>
          {i18n`dlv_dac7_infocard_requirements_intro`}
        </Paragraph3>
        <ul>
          <S.Li>{i18n`dlv_dac7_infocard_requirement_1`}</S.Li>
          <S.Li>{i18n`dlv_dac7_infocard_requirement_2`}</S.Li>
        </ul>
        <Paragraph3 fontWeight={400} mb={16}>
          {i18n`dlv_dac7_infocard_requirements_description`}
        </Paragraph3>
        <Paragraph3 mb={16}>{i18n`dlv_dac7_infocard_requirements_bold_text`}</Paragraph3>
        <Paragraph4>
          {i18n`dlv_dac7_infocard_help_center_text`}
          <S.Link href={i18n`dlv_dac7_infocard_help_center_link_url`} target="_blank">
            {i18n`dlv_dac7_infocard_help_center_link_text`}
          </S.Link>
        </Paragraph4>
      </S.ContentContainer>
    </S.InfoCardContainer>
  );
};

export default Dac7InfoCard;
